const MainMenu = [
  {
    id: 1,
    name: 'Инфопанель',
    icon: 'ios-navigate',
    path: '/'
  },
  {
    id: 2,
    name: 'Новости',
    icon: 'ionic',
    path: '/news'
  },
  {
    id: 4,
    name: 'Задачи',
    icon: 'ios-browsers',
    path: '/tasks'
  },
  {
    id: 8,
    name: 'Клиенты',
    icon: 'android-contacts',
    path: '/partners'
  },
  {
    id: 10,
    name: 'Заявки',
    icon: 'android-list',
    path: '/finixOrders'
  },
  {
    id: 11,
    name: 'Отчет по заявкам',
    icon: 'stats-bars',
    path: '/finixOrdersReport'
  },
  {
    id: 3,
    name: 'Продажи',
    icon: 'ios-cart',
    isGroup: false,
    children: [
      {
        id: 302,
        name: 'Продажи',
        icon: 'ios-cart',
        path: '/sales'
      },
      {
        id: 308,
        name: 'Возвраты',
        icon: 'ios-copy',
        path: '/refunds'
      },
      {
        id: 303,
        name: 'Краткий дневной отчет',
        icon: 'ios-copy',
        path: '/salesDailyBriefReport'
      },
      {
        id: 305,
        name: 'Отчет по товарным операциям',
        icon: 'ios-copy',
        path: '/goodsOperationsReport'
      },
      {
        id: 307,
        name: 'Отчет для анализа закупки',
        icon: 'ios-copy',
        path: '/purchaseAnalysisReport'
      },
      {
        id: 306,
        name: 'Рейтинг',
        icon: 'ios-copy',
        path: '/salesRatingReport'
      },
      {
        id: 304,
        name: 'Фискальный регистратор',
        icon: 'ios-cog',
        path: '/fiscalDevice'
      },
      {
        id: 309,
        name: 'Удаление товарных операциий',
        icon: 'ios-copy',
        path: '/goodsOperationsDeleting'
      },
      {
        id: 301,
        name: 'Планы продаж',
        icon: 'stats-bars',
        isGroup: true,
        children: [
          {
            id: 30101,
            name: 'По дням для магазинов',
            icon: 'stats-bars',
            path: '/salePlansForShops'
          },
          {
            id: 30102,
            name: 'По дням для продавцов',
            icon: 'stats-bars',
            path: '/salePlansForPersons'
          }
        ]
      }
    ]
  },
  {
    id: 5,
    name: 'Финансы',
    icon: 'card',
    isGroup: false,
    children: [
      {
        id: 501,
        name: 'Бюджет',
        icon: 'cash',
        isGroup: true,
        children: [
          {
            id: 50101,
            name: 'Плановые доходы',
            icon: 'cash',
            path: '/incomesPlans'
          },
          {
            id: 50102,
            name: 'Плановые расходы',
            icon: 'cash',
            path: '/expensesPlans'
          },
          {
            id: 50103,
            name: 'БДР',
            icon: 'cash',
            path: '/incomesAndExpensesBudget'
          },
          {
            id: 50104,
            name: 'БДДС',
            icon: 'cash',
            path: '/incomesAndExpenses'
          }
        ]
      },
      {
        id: 502,
        name: 'На магазинах',
        icon: 'cash',
        isGroup: true,
        children: [
          {
            id: 50201,
            name: 'Отчеты по кассе',
            icon: 'cash',
            path: '/shopsCashboxDailyReports'
          },
          {
            id: 50202,
            name: 'Инкассации',
            icon: 'cash',
            path: '/shopsInkassacii'
          },
          {
            id: 50203,
            name: 'Расходы на магазинах',
            icon: 'cash',
            path: '/shopsExpenses'
          },
          {
            id: 50204,
            name: 'Возвраты денег за товар',
            icon: 'cash',
            path: '/shopsRefunds'
          }
        ]
      }
    ]
  },
  {
    id: 6,
    name: 'Товары',
    icon: 'pricetags',
    isGroup: false,
    children: [
      {
        id: 601,
        name: 'Брак',
        icon: 'pricetag',
        path: '/goodsDefects'
      },
      {
        id: 602,
        name: 'Цена товара',
        icon: 'pricetag',
        path: '/goodsPriceQuickChanging'
      }
    ]
  },
  {
    id: 7,
    name: 'Отчеты',
    icon: 'ios-paper',
    isGroup: false,
    children: [
      {
        id: 701,
        name: 'Счетчики посетителей',
        icon: 'ios-paper',
        path: '/shopsVisitors'
      }
    ]
  },
  {
    id: 9,
    name: 'СБ',
    icon: 'jet',
    isGroup: false,
    children: [
      {
        id: 901,
        name: 'Краткий дневной отчет',
        icon: 'ios-copy',
        path: '/salesDailyBriefReport'
      },
      {
        id: 902,
        name: 'Отчет по товарным операциям',
        icon: 'ios-copy',
        path: '/goodsOperationsReport'
      },
      {
        id: 903,
        name: 'Рейтинг',
        icon: 'ios-copy',
        path: '/salesRatingReport'
      }
    ]
  },
  {
    id: 97,
    name: 'CMS',
    icon: 'nuclear',
    isGroup: false,
    children: [
      {
        id: 9701,
        name: 'Конфигурация',
        icon: 'ionic',
        path: '/cms/config'
      },
      {
        id: 9702,
        name: 'Страницы',
        icon: 'ionic',
        path: '/cms/pages'
      },
      {
        id: 9703,
        name: 'Контент',
        icon: 'ionic',
        path: '/cms/content'
      },
      {
        id: 9704,
        name: 'Блоки',
        icon: 'ionic',
        path: '/cms/blocks'
      },
      {
        id: 9705,
        name: 'Меню',
        icon: 'ionic',
        path: '/cms/menus'
      }
    ]
  },
  {
    id: 98,
    name: 'Админпанель',
    icon: 'nuclear',
    isGroup: false,
    children: [
      {
        id: 9801,
        name: 'Новости',
        icon: 'ionic',
        path: '/adminPanel/news'
      },
      {
        id: 9804,
        name: 'Финансы',
        icon: 'briefcase',
        isGroup: false,
        children: [
          {
            id: 980401,
            name: 'Кассы',
            icon: 'briefcase',
            path: '/adminPanel/financeBoxes'
          },
          {
            id: 980402,
            name: 'Тэги',
            icon: 'pricetags',
            path: '/adminPanel/financeTags'
          }
        ]
      },
      {
        id: 9806,
        name: 'Банки',
        icon: 'briefcase',
        path: '/adminPanel/finixBanks'
      },
      {
        id: 9802,
        name: 'Пользователи',
        icon: 'android-contacts',
        path: '/adminPanel/users'
      },
      {
        id: 9803,
        name: 'Права доступа',
        icon: 'person-stalker',
        path: '/adminPanel/permissions'
      },
      {
        id: 9805,
        name: 'Вендинг',
        icon: 'ionic',
        path: '/adminPanel/vending'
      }
    ]
  },
  {
    id: 99,
    name: 'Профиль',
    icon: 'android-contact',
    path: '/profile'
  }
]

export default MainMenu



// WEBPACK FOOTER //
// ./src/components/MainMenu/mainMenuTemplateBASE.json.js